import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UnsubscribeService } from '@app/infrastructure/unsubscribe/unsubscribe.service';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-error-screen',
	templateUrl: './error-screen.component.html',
	styleUrls: ['./error-screen.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [UnsubscribeService],
})
export class ErrorScreenComponent implements OnInit {
	public readonly settingsRoute = `/${AppRouteHelper.userProfile}`;
	public errorMessage: string;

	constructor(private route: ActivatedRoute, private unsubscribe$: UnsubscribeService) {}

	public ngOnInit(): void {
		this.route.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((params) => {
			this.errorMessage = params.error;
		});
	}
}
